export default __webpack_public_path__ + "static/illustration-4-7d9322b5e75e1543c0e7c10f233b1c61.png";